import { Paper, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { versionClient } from '../../api/client';
import { VersionInfo } from '../../api/schema';

// Baked into the bundle at image-build time (Dockerfile ARG VERSION -> REACT_APP_VERSION).
// Local `npm start` shows 'dev'.
const feVersion = process.env.REACT_APP_VERSION ?? 'dev';

export const About: React.FC = () => {
  const [beVersion, setBeVersion] = useState<VersionInfo | null>(null);
  const [beError, setBeError] = useState(false);

  useEffect(() => {
    let active = true;
    versionClient
      .getVersion()
      .then((res) => {
        if (active) {
          setBeVersion(res.data.result ?? null);
        }
      })
      .catch(() => {
        if (active) {
          setBeError(true);
        }
      });
    return () => {
      active = false;
    };
  }, []);

  const beVersionLabel = beError ? 'unavailable' : beVersion?.version ?? '…';

  return (
    <Paper sx={{ p: 4 }}>
      <Box sx={{ maxWidth: 600 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          About The Tag System
        </Typography>
        <p>
          TheTagSystem© is a real-time RFID asset tracking platform. It tracks tools across a company’s tool rooms, vehicles, and job sites to prevent loss and
          optimize their usage. Tracking units mounted in vehicles and at fixed sites continuously scan for RFID-tagged tools and report to the TheTagSystem©
          datacenter, where scans are processed into live locations, usage history, and alerts delivered by SMS and email.
        </p>
        <Typography variant="h4" sx={{ mt: 6, mb: 2 }}>
          Versions
        </Typography>
        <Table size="small" sx={{ maxWidth: 400 }}>
          <TableBody>
            <TableRow>
              <TableCell>
                <strong>Frontend</strong>
              </TableCell>
              <TableCell>{feVersion}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Backend</strong>
              </TableCell>
              <TableCell>{beVersionLabel}</TableCell>
            </TableRow>
            {beVersion?.sha && (
              <TableRow>
                <TableCell>Backend build</TableCell>
                <TableCell>
                  {beVersion.sha.substring(0, 12)}
                  {beVersion.built_at ? ` — ${beVersion.built_at}` : ''}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
          Frontend and backend are versioned from the same source tree and normally match; they can differ briefly while a deployment is in progress.
        </Typography>
      </Box>
    </Paper>
  );
};
